import enMessages from 'locales/en_US';

export default {
  intl: {
    defaultLocale: 'en',
    locale: 'en',
    messages: enMessages,
  },
};
